export const COMPONENT_NAME = 'SearchBar';